/* global axios */
import WhatsAppSipApiClient from './index';

class WhatsAppSipQueuesAPI extends WhatsAppSipApiClient {
  constructor() {
    super('queues');
  }

  // GET /api/v1/accounts/:account_id/whatsapp_sip/queues
  get() {
    return axios.get(this.url);
  }

  // GET /api/v1/accounts/:account_id/whatsapp_sip/queues/:id
  show(id) {
    return axios.get(`${this.url}/${encodeURIComponent(id)}`);
  }

  // POST /api/v1/accounts/:account_id/whatsapp_sip/queues
  create(data) {
    return axios.post(this.url, data);
  }

  // PUT /api/v1/accounts/:account_id/whatsapp_sip/queues/:id
  update(id, data) {
    return axios.put(`${this.url}/${encodeURIComponent(id)}`, data);
  }

  // DELETE /api/v1/accounts/:account_id/whatsapp_sip/queues/:id
  delete(id) {
    return axios.delete(`${this.url}/${encodeURIComponent(id)}`);
  }

  addMember(id, extension) {
    return axios.post(`${this.url}/${encodeURIComponent(id)}/add_member`, {
      extension,
    });
  }

  removeMember(id, extension) {
    return axios.post(`${this.url}/${encodeURIComponent(id)}/remove_member`, {
      extension,
    });
  }

  pauseMember(id, extension, reason) {
    return axios.post(`${this.url}/${encodeURIComponent(id)}/pause_member`, {
      extension,
      reason,
    });
  }

  unpauseMember(id, extension) {
    return axios.post(`${this.url}/${encodeURIComponent(id)}/unpause_member`, {
      extension,
    });
  }
}

export default new WhatsAppSipQueuesAPI();
